import { InformationPage } from "../../../../common/components/informationPage/InformationPage";
import { IMG_ORDER_SUCCESS } from "../../../../utils/url/staticResources";
import { HOMEPAGE } from "../../../../utils/url/staticUrls";
import { Trans, useTranslation } from "react-i18next";
import { QualtricsContainer } from "~/ProductDetails/components/ProductSummary/common/QualtricsContainer";
import { FCCGapProductRecommendation } from "../../../SaleRecommendations/FCCRecommendationsSection/SchaefflerFCCGapProductsRecommendationComponent";
import { PurchasePlaceProvider } from "~/feature/Analytics/ga/recommendations/RecommendationContexts";

export const OrderConfirmationPage = () => {
  const { t } = useTranslation();
  const { SCHA: windowOpts } = window;

  return (
    <>
      <InformationPage.CenterContents>
        <InformationPage.Title as={"h1"} className={"display-small mb-3 mt-60"}>
          {t("orderConfirmationPage.thankYou")}
        </InformationPage.Title>
        <InformationPage.Image src={IMG_ORDER_SUCCESS} />
        <QualtricsContainer id={"orderConfirmationFeedback"} />
        <InformationPage.CtaButton id={"confirmation_bt_homepage_btn"} href={HOMEPAGE}>
          {t("orderConfirmationPage.backToShop")}
        </InformationPage.CtaButton>
        <InformationPage.InformationMessage>
          <div>
            <Trans
              i18nKey={"checkout.orderConfirmation.footerMessage"}
              components={{ linkElement: <a href={windowOpts.urls.contactUs} /> }}
            />
          </div>
        </InformationPage.InformationMessage>
      </InformationPage.CenterContents>
      <FCCGapProductRecommendation />
    </>
  );
};

export function createOrderConfirmationPage() {
  return (
    <PurchasePlaceProvider value={"OC"}>
      <OrderConfirmationPage />
    </PurchasePlaceProvider>
  );
}
